/* eslint-disable @typescript-eslint/no-explicit-any */
import { Controller } from "@hotwired/stimulus";

export interface DebounceOptions {
  name?: string;
  wait?: number;
}

export type StimulusFunction = (...args: any[]) => any;

class DebounceController extends Controller {
  static debounces: Array<DebounceOptions | string> = [];
}

const defaultWait = 200;

export const debounce = (
  fn: StimulusFunction,
  wait: number = defaultWait,
): any => {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  return function (this: any): any {
    // eslint-disable-next-line prefer-rest-params
    const args = Array.from(arguments);
    const params = args.map((arg) => arg.params);

    const callback = (): any => {
      args.forEach((arg, index) => (arg.params = params[index]));
      return fn.apply(this, args);
    };

    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(callback, wait);
  };
};

export const debounceController = (
  composableController: Controller,
  options?: DebounceOptions,
): void => {
  const controller = composableController as DebounceController;
  const constructor = controller.constructor as typeof DebounceController;

  constructor.debounces.forEach((func: DebounceOptions | string) => {
    if (typeof func === "string") {
      (controller as any)[func] = debounce(
        (controller as any)[func] as StimulusFunction,
        options?.wait,
      );
    }

    if (typeof func === "object") {
      const { name, wait } = func;
      if (name === null || name === undefined) return;
      (controller as any)[name] = debounce(
        (controller as any)[name] as StimulusFunction,
        wait ?? options?.wait,
      );
    }
  });
};
